import React from "react";
import { UILeg } from "@flights/types";

import { createTrackingUtils } from "..";
import useUserAgent from "../../../hooks/useUserAgent";

// Tracking https://experiment.booking.com/experiments/flights_pb_universal_alias_email_removal/2291860/info
const EXCLUDED_EMAIL_CARRIERS = ["W4", "W6", "W9", "5W", "EW", "AD", "TK", "VY", "AA", "G3", "A3", "FD", "GQ", "U2"];

export const trackAliasEmailRemoval = createTrackingUtils({
  defaultStage: 1,
  name: "flights_pb_universal_alias_email_removal",
  stages: {
    AFFECTED_USERS: 1,
    CHECKIN_PAGE: 2,
    CHECKIN_PAGE_DESKTOP: 3,
    CHECKIN_PAGE_MDOT: 4,
    CHECKIN_PAGE_IOS: 5,
    CHECKIN_PAGE_ANDROID: 6
  },
  goals: {
    FLIGHTS_WEB_APPS_HC_CLICK: 1,
    CHECKIN_VIA_AIRLINE_WEBSITE_CTA: 2
  },
  goalsWithValue: []
});

export const useTrackAliasEmailRemoval = (leg: UILeg) => {
  const { isMobile } = useUserAgent();

  React.useEffect(() => {
    const hasExcludedCarrier =
      !!leg.flightInfo.carrierInfo?.marketingCarrier &&
      EXCLUDED_EMAIL_CARRIERS.includes(leg.flightInfo.carrierInfo.marketingCarrier);

    if (hasExcludedCarrier) {
      trackAliasEmailRemoval.stages.CHECKIN_PAGE();

      isMobile
        ? trackAliasEmailRemoval.stages.CHECKIN_PAGE_MDOT()
        : trackAliasEmailRemoval.stages.CHECKIN_PAGE_DESKTOP();
    }
  }, [isMobile, leg]);
};
